import React from "react";

import { Modal } from "../Modal";
import { Button } from "../../UI/Button";
import { useModalContext } from "../../contexts/ModalContext/context";
import { Typography } from "../../UI/Typography";
import { Grid } from "../../UI/Grid";
import { Box } from "../../UI/Box";

interface IProps {
  gender: string;
  handleDelete: VoidFunction;
}

export const GenderDeleteModal: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();

  const handleClose = () => setIsOpen(false);

  return (
    <Modal
      maxWidth="xs"
      title="Delete Gender Option"
      actions={
        <Grid container spacing={1} justifyContent="flex-end">
          <Grid item>
            <Button onClick={handleClose}>Cancel</Button>
          </Grid>
          <Grid item>
            <Button appearance="danger" onClick={props.handleDelete}>
              Delete Gender Option
            </Button>
          </Grid>
        </Grid>
      }
    >
      <Box px={3} py={2}>
        <Typography paragraph>
          You are about to delete a gender option. Users that have selected this gender option will be prompted to
          select a new gender option.
        </Typography>
        <Typography paragraph>
          <strong>Gender Option to Delete:</strong> {props.gender}
        </Typography>
      </Box>
    </Modal>
  );
};
